module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("À votre service")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Par Ariel Tachna")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lorsqu’Anthony Mercer est entré dans le restaurant Au cœur du terroir, il était à la recherche d’un bon repas et d’une soirée agréable passée avec une amie. Il ne s’attendait pas à rencontrer – et encore moins coucher avec – Paul Delescluse, un serveur du restaurant. Après avoir passé une semaine magique ensemble à Paris, Anthony doit retourner à sa vie en Caroline du Nord, tandis que Paul reste en France.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Malgré la distance et l’absence de promesses entre eux – Paul veut du sexe, pas une relation – Paul et Anthony forgent une amitié solide. Puis le travail d’Anthony le ramène à Paris, cette fois pour y rester. Paul est très heureux qu’il soit de retour, mais Anthony a un choix difficile à faire : être une autre des conquêtes de Paul, ou lutter pour obtenir la relation qu’ils pourraient avoir, si seulement Paul voulait bien y croire.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf91d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0001.vue
// module id = 57
// module chunks = 0